import Label from "./Label";

export default function Checkbox({ label, name, value, checked, onChange, labelStyle, ...props }) {
    return (
        <Label text={label} horizontalStyle customStyle={labelStyle}>
            <input 
                type="checkbox" 
                name={name} 
                className={`checkbox`} 
                checked={checked} 
                onChange={onChange}
                value={value}
                {...props}
            />
        </Label>
    )
}
